module.exports = __webpack_public_path__ + "img/visa-electron.9b5cc99d.svg";